module.exports = __webpack_public_path__ + "img/mhp.3f5b2374.jpg";